import { useTranslation } from 'react-i18next';

import EmailSubmitted from '../NotificationFlow/EmailSubmitted';
import type { ScreenProps } from '.';

type Props = ScreenProps & {
  email: string;
};

export default function SignUpCompleteScreen({ email, modalType }: Props) {
  const { t } = useTranslation();

  return (
    <EmailSubmitted
      email={email}
      warning={
        modalType === 'notifications'
          ? t('login.stageComplete.notificationsWarning')
          : t('login.stageComplete.signUpWarning')
      }
    />
  );
}
